import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AttentionBlock, Button, Paragraph } from "@nn-design-system/react-component-library";
import useFetch from "../../CustomHooks/useFetch";
import { login, setStelaContext, setUserAuthenticationStatus } from "../../redux/reducers/authReducer";
import { setToken } from "../../redux/reducers/tokenReducer";

type StelaInsuredPersonResponse = {
   firstname: string;
   lastname: string;
   personalId: string;
};

type StelaCallbackResponse = {
   jwtToken: string;
   proposalNumber: string;
   insuredPersonBirthNumber: string;
   insuredPersons: StelaInsuredPersonResponse[];
   returnUrl: string;
   agentId?: string;
   agentFirstname?: string;
   agentLastname?: string;
    agentIco?: string;
    agentPhone?: string;
    agentEmail?: string;
};

const StelaEntryPage: React.FC = () => {
   const [errorMessage, setErrorMessage] = useState<string | null>(null);
   const [returnUrl, setReturnUrl] = useState<string>("");
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const { sendRequest, data, error } = useFetch<StelaCallbackResponse>();

   useEffect(() => {
      const token = new URLSearchParams(window.location.search).get("token");

      if (!token) {
         setErrorMessage("Chybí přihlašovací token.");
         return;
      }

      sendRequest({
         method: "POST",
         url: `${process.env.REACT_APP_BaseURL}/stela2/callback`,
         headers: { "Content-Type": "application/json" },
         data: { token },
      });
   }, []);

   useEffect(() => {
      if (!data) {
         return;
      }

      dispatch(setToken(data.jwtToken));
      dispatch(setStelaContext({
         proposalNumber: data.proposalNumber,
         insuredPersonBirthNumber: data.insuredPersonBirthNumber,
         entryJwtToken: data.jwtToken,
         insuredPersons: data.insuredPersons.map((person) => ({ ...person, isNotInsured: false })),
         returnUrl: data.returnUrl,
         agentId: data.agentId ?? "",
         agentFirstname: data.agentFirstname ?? "",
         agentLastname: data.agentLastname ?? "",
          agentIco: data.agentIco ?? "",
          agentPhone: data.agentPhone ?? "",
          agentEmail: data.agentEmail ?? "",
      }));
      dispatch(login());
      dispatch(setUserAuthenticationStatus("agent"));
      navigate("/personSelection/stela");
   }, [data, dispatch, navigate]);

   useEffect(() => {
      const response = error?.response;
      if (!response) {
         return;
      }

      if (response.status === 404) {
         setReturnUrl(response.data?.returnUrl ?? "");
         setErrorMessage("Smlouvu se nepodařilo najít.");
      } else if (response.status === 401) {
         setErrorMessage("Přihlášení se nepodařilo ověřit.");
      } else {
         setErrorMessage("Nepodařilo se zahájit hlášení škody.");
      }
   }, [error]);

   return (
      <div>
         {errorMessage ? (
            <div>
               <AttentionBlock mt="1rem" mb="1rem" variant="Warning">
                  <Paragraph>{errorMessage}</Paragraph>
               </AttentionBlock>
               {returnUrl && (
                  <Button onClick={() => { window.location.href = returnUrl; }}>
                     Zpět
                  </Button>
               )}
            </div>
         ) : (
            <AttentionBlock mt="1rem" mb="1rem" variant="Informative">
               <Paragraph>Probíhá přihlašování, počkejte prosím...</Paragraph>
            </AttentionBlock>
         )}
      </div>
   );
};

export default StelaEntryPage;
